import React, { useState } from 'react';

import CardView from '../common/CardView/CardView';
import NavTabGroup from '../common/NavTabGroup/NavTabGroup';

import LogsIndex from './LogsIndex';

type LogsPanelProps = {
  pipelineID: string,
  isAnomalyDetectionEnabled: boolean,
}

export const LogsPanel = ({ pipelineID, isAnomalyDetectionEnabled = false }: LogsPanelProps) => {
  const [selectedLogTab, setSelectedLogTab] = useState('Audit Log');

  const tabOptions = [
    {
      value: 'Audit Log',
    },
    {
      value: 'Anomaly Log',
      disabled: !isAnomalyDetectionEnabled,
    }
  ]
  return (
    <CardView className="pt-2 px-8 pb-0 mb-4 h-96" disableFullHeight>
      <NavTabGroup
        options={tabOptions}
        selectedTab={selectedLogTab}
        onTabSelected={setSelectedLogTab}
      />
      <LogsIndex
        isHidden={selectedLogTab !== 'Audit Log'}
        pipelineID={pipelineID}
      />
      <LogsIndex
        isHidden={selectedLogTab !== 'Anomaly Log'}
        pipelineID={pipelineID}
      />
      <LogsIndex
        isHidden={selectedLogTab !== 'error'}
        pipelineID={pipelineID}
      />
    </CardView>
  );
};
export default LogsPanel;
